<div class="card panel-flat-color primary-panel ws-flex-auto m-0 d-flex flex-column">
    <div class="panel-flat-header">
        <div class="float-start">
            <h3 helpTooltip
                helpContentId="filing-batch-accounts.panel"
                position="bottom">
                Filings
                <ag-grid-row-count [gridApi]="gridApi"
                                   [gridTracker]="gridTracker"
                                   [gridOptions]="gridOptions"
                                   [cssClass]="null"></ag-grid-row-count>
            </h3>
        </div>
        <div class="float-end header-button-container d-flex">
            <div class="action-button-wrapper"
                 helpTooltip
                 [helpContentId]="moveHelpContentId"
                 position="bottom">
                @if (canEdit()) {
                    <button type="button"
                            class="ace-btn btn-text btn-link"
                            [disabled]="(!canEnterEditMode) || editMode || isBusy || !(selectedRows && selectedRows.length)"
                            (click)="moveFilings()">
                        <i class="fa fa-arrow-circle-right fa-align"></i> Move Filings
                    </button>
                }
            </div>
            <div class="action-button-wrapper"
                 helpTooltip
                 [helpContentId]="addHelpContentId"
                 position="bottom">
                @if (canEdit()) {
                    <button type="button"
                            class="ace-btn btn-text btn-link"
                            [disabled]="((!editMode) && !canEnterEditMode) || isBusy"
                            (click)="add()">
                        <i class="fa fa-plus-circle fa-align"></i> Add Filings
                        @if (isAvailableBusy) {
                            <ws-ace-loader [inline]="true"></ws-ace-loader>
                        }
                        @if (!isAvailableBusy) {
                            <span>({{ (availableFilingCount || 0) | number }} available)</span>
                        }
                    </button>
                }
            </div>
            <div class="action-button-wrapper"
                 helpTooltip
                 [helpContentId]="editHelpContentId"
                 position="bottom">
                @if (canEdit() && !editMode) {
                    <button type="button"
                            class="ace-btn btn-text has-icon btn-primary"
                            [disabled]="(!canEnterEditMode) || isBusy"
                            (click)="edit()">
                        <i class="fa fa-pencil fa-align"></i>
                    </button>
                }
            </div>
            <div class="action-button-wrapper"
                 helpTooltip
                 helpContentId="app.save"
                 position="bottom">
                @if (editMode) {
                    <button type="button"
                            class="ace-btn btn-text has-icon btn-primary"
                            [disabled]="(!hasChanges) || isBusy"
                            (click)="save()">
                        <i class="fa fa-save fa-align"></i>
                    </button>
                }
            </div>
            <div class="action-button-wrapper"
                 helpTooltip
                 helpContentId="app.cancel"
                 position="bottom">
                @if (editMode) {
                    <button type="button"
                            class="ace-btn btn-text has-icon btn-primary"
                            (click)="cancel()">
                        <i class="fa fa-times fa-align"></i>
                    </button>
                }
            </div>
            <div class="action-button-wrapper"
                 helpTooltip
                 helpContentId="app.expand"
                 position="bottom">
                @if (!isExpanded) {
                    <button type="button"
                            class="ace-btn btn-text has-icon btn-secondary"
                            (click)="expandComponent()">
                        <i class="fa fa-arrows-alt"></i>
                    </button>
                }
            </div>
            <div class="action-button-wrapper"
                 helpTooltip
                 helpContentId="app.collapse"
                 position="bottom">
                @if (isExpanded) {
                    <button type="button"
                            class="ace-btn btn-text has-icon btn-secondary"
                            (click)="collapseComponent()">
                        <i class="fa fa-compress"></i>
                    </button>
                }
            </div>
        </div>
    </div>
    <div class="panel-flat-body d-flex flex-column h-100 m-0">
        <ws-ag-grid-angular [gridOptions]="gridOptions"
                            (gridReady)="onAgGridReady($event)"
                            [companyId]="companyId"
                            [gridId]="gridId"
                            [isBulkDeleteVisible$]="isBulkDeleteVisible$"
                            (bulkDelete)="bulkDelete()">
        </ws-ag-grid-angular>
    </div>
</div>
